import React from 'react';
import { motion } from 'framer-motion';
import Constants from '../../../app/utils/constants'
import colors from '../../theme/color'

const SolutionSection = () => {
  const { portfolioSolutionItems } = Constants

  return (
    <section className="mx-auto mt-20 w-full text-white">
      <div className="relative w-full overflow-hidden rounded-[40px] border border-[#FFFFFF33] bg-[#FFFFFF0A] p-6 backdrop-blur-md md:px-10 lg:px-12 xl:px-16">

        {/* 🔥 MOVING GLOW (unchanged) */}
        <style>{`
          .glow-orb {
            position: absolute;
            width: 320px;
            height: 320px;
            border-radius: 50%;
            background: #8FE64A;
            filter: blur(80px);
            opacity: 0.65;
            offset-path: border-box;
            animation: glowTrack 35s linear infinite;
          }

          .glow-orb-2 {
            animation-delay: -18s;
            opacity: 0.45;
          }

          @keyframes glowTrack {
            from { offset-distance: 0%; }
            to   { offset-distance: 100%; }
          }
        `}</style>

        <div className="pointer-events-none absolute inset-0 rounded-[40px] overflow-hidden">
          <div className="glow-orb" />
          <div className="glow-orb glow-orb-2" />
        </div>

        {/* HEADING */}
        <h2 className="relative z-10 mb-10 text-center text-2xl font-gilroy-bold text-white md:mb-12 md:text-4xl lg:text-5xl xl:text-6xl">
          Solution We Engineered
        </h2>

        {/* GRID */}
        <div className="relative z-10 grid grid-cols-2 md:grid-cols-3 gap-4 lg:gap-8 xl:gap-10 2xl:gap-10">
          {portfolioSolutionItems.map((item, idx) => {

            // 👇 Detect position
            const colIndex = idx % 3

            let initial = {}
            let animate = {}

            if (colIndex === 0) {
              // LEFT COLUMN
              initial = { x: -80, opacity: 0 }
              animate = { x: 0, opacity: 1 }
            } else if (colIndex === 2) {
              // RIGHT COLUMN
              initial = { x: 80, opacity: 0 }
              animate = { x: 0, opacity: 1 }
            } else {
              // CENTER COLUMN
              initial = { scale: 0.7, opacity: 0 }
              animate = { scale: 1, opacity: 1 }
            }

            return (
              <motion.div
                key={idx}
                initial={initial}
                whileInView={animate}
                viewport={{ once: false, margin: '-50px' }} 
                transition={{ duration: 0.6, ease: 'easeIn' }}
                whileHover={{ scale: 1.05 }}
                className="items-start gap-4 rounded-[40px] p-3 md:p-6 lg:p-8 xl:p-10 2xl:p-10"
                style={{ backgroundColor: colors.portfolioGreen }}
              >

                {/* ICON */}
                <div className="flex h-12 w-full shrink-0 items-center justify-center md:justify-start rounded-xl md:h-14 md:w-10">
                  <motion.img
                  src={item.icon}
                  alt=""
                  className="h-6 w-6 md:h-7 md:w-7 lg:h-10 lg:w-10 xl:h-12 xl:w-12 2xl:h-14 2xl:w-14"
                  animate={{ scale: [1, 1.3, 1] }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: 'easeIn',
                  }}
                />
                </div>

                {/* TEXT */}
                <p className="text-center md:text-left font-gilroy-medium text-sm leading-snug text-black md:text-base lg:text-lg xl:text-xl 2xl:text-2xl">
                  {item.text}
                </p>

              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default SolutionSection